module.exports = __webpack_public_path__ + "static/media/Vocal_Sight_Reading_Evaluation_Rubric.c93b22a7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Vocal_Sight_Reading_Evaluation_Rubric.pdf
// module id = 230
// module chunks = 0